/**
 * @file 处理资源位实时数据上报
 */
import { ajax } from '../core/ajax'

/**
 * 资源位实时数据上报通用方法，可处理展现/关闭/点击三种事件
 * @param {object} activity 活动对象信息
 * @param {1|2|3} trackType 事件类型 1点击 2关闭 3展现
 */
function businessResourceLog ({ activity, trackType }) {
  if (!activity) {
    return
  }
  let tracks = []
  switch (trackType) {
    case 1:
      tracks = activity.click_tracks || []
      break
    case 2:
      tracks = activity.close_tracks || []
      break
    case 3:
      tracks = activity.imp_tracks || []
      break
    default:
      break
  }
  let logData = activity.log_data
  tracks.forEach((url) => {
    let data = Object.assign({
      st: new Date().getTime()
    }, logData)
    ajax({
      url,
      data
    })
  })
}

export default {
  businessResourceLog
}